import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import CloudStorage from "../../../../CloudStorage/CloudStorage";
import TeamsProjectDetails from "./TeamsProjectDetails/TeamsProjectDetails";
import TeamsProjectModel from "./TeamsModels/TeamsProjectModel";
import { getTeamProject } from "../../../../redux/team/action";
import CustomeCircularProgressbar from "../../../Common/CustomeLabel/CustomeCircularProgressbar";
import { getPercentage } from "../../../Common/FewCommonMethods";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import { decodeHtml } from "../../../../assests/extention/commonfunction";

export default function TeamsTasklist({ serachkey, setSerachkey, projectId, setProjectID, projectDetails, setProjectDetails }) {
  const dispatch = useDispatch();

  const [projectModel, setProjectModel] = useState(false);
  const [searchedProject, setSearchedProject] = useState([]);

  const projectLists = useSelector(({ team: { getteamprojects } }) => getteamprojects);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  // Fetch projects
  useEffect(() => {
    dispatch(getTeamProject());
  }, [dispatch]);

  // Update state when project list changes
  useEffect(() => {
    if (Array.isArray(projectLists)) {
      setProjectDetails(projectLists);
      setSearchedProject(projectLists);
    }
  }, [projectLists]);

  // Handle search
  useEffect(() => {
    if (serachkey.trim() !== "") {
      const filtered = projectLists.filter((p) =>
        p.title.toLowerCase().includes(serachkey.toLowerCase())
      );
      setSearchedProject(filtered);
    } else {
      setSearchedProject(projectLists);
    }
  }, [serachkey, projectLists]);

  // Handle modal body scroll
  useEffect(() => {
    if (projectModel) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [projectModel]);

  // JSX
  return (
    <>
      {projectId != 0 ? (
        <TeamsProjectDetails
          projectid={projectId}
          setProjectID={setProjectID}
          projectdetails={projectDetails}
          setProjectdetails={setProjectDetails}
        />
      ) : (
        <div className="teamtask">
          {/* Header */}
          <div className="invite-member">
            <h4>Project Boards</h4>
            <div className="message-right">
              <div className="search-bar">
                <input
                  type="search"
                  placeholder="Search Here"
                  className="form-control"
                  value={serachkey}
                  onChange={(e) => setSerachkey(e.target.value)}
                />
                <button className="btn search-btn">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/search-lg.svg`}
                    alt="Search"
                  />
                </button>
              </div>
            </div>
          </div>

          {/* Project list */}
          <div className="row teamtask-row">
            {/* Show create project option for company role */}
            {profile?.role_type === 4 && (
              <div className="col-md-4">
                <div
                  className="create-project"
                  onClick={() => setProjectModel(true)}
                >
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
                      alt="Create"
                    />
                    Create project board
                  </p>
                </div>
              </div>
            )}

            {/* Projects */}
            {Array.isArray(searchedProject) && searchedProject.length > 0 ? (
              searchedProject.map((item, index) => (
                <div
                  key={index}
                  className="col-md-4 create-background"
                  onClick={() => {
                    setProjectID(item.id);
                    setProjectDetails(item);
                  }}
                >
                  <div className="create-project1">
                    <div>
                      <h4>{decodeHtml(item.title)}</h4>
                      <h6>{item.task}</h6>
                      <div className="task-img">
                        {item.users
                          ?.slice(0, 3)
                          .map((user, i) => (
                            <ProfileImageWithFallback
                              key={i}
                              url={user.profile_image}
                              alt="User"
                            />
                          ))}
                        {item.user_count > 3 && (
                          <span>+{item.user_count - 3}</span>
                        )}
                      </div>
                    </div>
                    <div style={{ width: 100 }}>
                      <CustomeCircularProgressbar
                        percentage={getPercentage(item.task, item.completed_task)}
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12">
                <div className="create-project create-datanotfound">
                  <img src={`${CloudStorage.cloudurl}/Assets/Images/common/datanotfound.png`} alt="" />
                  <p>
                    No Task Available
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Modal */}
          <Modal className="popupmodal yes-no" isOpen={projectModel}>
            <TeamsProjectModel setProjectmodel={setProjectModel} />
          </Modal>
        </div>
      )}
    </>
  );
}
